import DocumentLoader from './DocumentLoader';

export default DocumentLoader;
